import React, { useEffect, useState } from "react";
import { defaultFilters } from "../utils/filters";

function loadFilters() {
  const defaults = defaultFilters();
  try {
    const saved = JSON.parse(localStorage.getItem("filters"));
    return saved && typeof saved === "object"
      ? { ...defaults, ...saved }
      : defaults;
  } catch (_) {
    return defaults;
  }
}

function FilterForm({ sendFiltersToParent, ariaLabel = "Insights filters" }) {

  const [filters, setFilters] = useState(loadFilters);

  useEffect(() => {
    sendFiltersToParent(filters)
  }, [filters]);

  const toggleFilter = (filterKey) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: !prevFilters[filterKey],
    }));
  };

  return (
      <div className="insightsGlobalFilters px-lg-3 pb-2 col-md-4" aria-label={ariaLabel}>
        <button
          type="button"
          className={`insightsGlobalFilter${filters.cryptoOnly ? " insightsGlobalFilterActive" : ""}`}
          aria-pressed={Boolean(filters.cryptoOnly)}
          onClick={() => toggleFilter("cryptoOnly")}
        >
          Crypto only
        </button>
        <button
          type="button"
          className={`insightsGlobalFilter${filters.aiValidatedOnly ? " insightsGlobalFilterActive" : ""}`}
          aria-pressed={Boolean(filters.aiValidatedOnly)}
          onClick={() => toggleFilter("aiValidatedOnly")}
        >
          AI validated only
        </button>
        <button
          type="button"
          className={`insightsGlobalFilter${filters.referenceOnly ? " insightsGlobalFilterActive" : ""}`}
          aria-pressed={Boolean(filters.referenceOnly)}
          title="Show results assessed with a reference pack, including neutral and conflicting assessments."
          onClick={() => toggleFilter("referenceOnly")}
        >
          Reference only
        </button>
      </div>
  );
}

export default FilterForm;
